
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refriver",
      function () {
        return require("private-next-pages/refriver/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refriver"])
      });
    }
  